export const RECEIVE_SEARCH_RESULT = 'receive_search_result'
export const RECEIVE_NAV_AREA = 'receive_nav_area'
export const RECEIVE_NAV_INDEX = 'receive_nav_index'
export const RECEIVE_SEARCH_NAME = 'receive_search_name'
export const RECEIVE_INDEX_NAV = 'receive_index_nav'
export const RECEIVE_FILTER_LIST = 'receive_filter_list'
export const RECEIVE_FILTER_QUERY = 'receive_filter_query'
export const RECEIVE_USER_INFO = 'receive_user_info'
export const RECEIVE_DETAIL_INFO = 'receive_detail_info'
export const RECEIVE_CURRENT_PAGE = 'receive_current_page'
export const RECEIVE_BOOK_ID = 'receive_book_id'
export const COUTER = 'COUTER'
export const READING_TYPE = 'reading_type' // 1 条目 2 整书

let LOGIN;
let READ;
if (process.env.NODE_ENV === 'production') {
  // 生产环境
  LOGIN = 'https://my.wanfangdata.com.cn/';
  READ = 'https://oss.wanfangdata.com.cn/';
} else if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
  // 测试环境
  LOGIN = 'http://my.rd.wanfangdata.com.cn/';
  READ = 'http://oss.rd.wanfangdata.com.cn/';
}
// 常量
export const IMG_BASE_URL = 'http://static.wanfangdata.com.cn/LocalChronicleImages/'
export const IMG_DEFAULT_URL = 'this.src="http://static.wanfangdata.com.cn/LocalChronicleImages/FZ201745248.gif"'
export const LOGIN_IN_URL = LOGIN + `auth/user/jglogin.do?service=`
export const LOGIN_OUT_URL = LOGIN + `auth/logout?service=`
// 阅读下载URL
export const READ_URL = READ + `fz/purchase?id=`
export const RESOURCE_TYPE_ITEM_READ = '&resourceType=localChronicleItemOpera'
export const RESOURCE_TYPE_ITEM_DOWN = '&resourceType=localChronicleItemOperaDownload'
export const RESOURCE_TYPE_READ = '&resourceType=localChronicleOpera'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js